<template>
	<div class="container">
		<el-card>
			<div slot="header">商户开户</div>
			<div class="centerBox">
				<el-form ref="recordForm" :model="recordForm" :rules="recordFormRules" label-width="150px">
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户编号" prop="code">
								<el-input v-model="recordForm.code" placeholder="获取商户编号自动生成此编号"
									style="width: calc(100% - 126px)" disabled></el-input>
								<el-button type="primary" @click="getMerchantType"
									style="background-color: #1c84c6 !important">获取商户编号</el-button>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="商户名称" prop="name">
								<el-input v-model="recordForm.name" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户联系人" prop="contactMan">
								<el-input v-model="recordForm.contactMan" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="电话" prop="phone">
								<el-input v-model="recordForm.phone" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="小程序联系人" prop="systemAdmin">
								<el-input v-model="recordForm.systemAdmin" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="电话" prop="systemAdminPhone">
								<el-input v-model="recordForm.systemAdminPhone" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="区域" prop="districtId">
								<el-cascader v-model="recordForm.districtId" :options="districtIdOptions" :props="props"
									clearable></el-cascader>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="地址" prop="address">
								<el-input v-model="recordForm.address" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="2">
							<el-form-item label="开启电账户">
								<el-checkbox v-model="recordForm.enableElectricAccountFlag" true-label="1"
									false-label="0" @change="electricAccountFlagChange"></el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item label="电费价格" label-width="140px">
								<el-input v-model="recordForm.electricPrice" clearable :disabled="electricAccountFlag">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :md="2">
							<el-form-item label="开启水账户">
								<el-checkbox v-model="recordForm.enableWaterAccountFlag" true-label="1" false-label="0"
									@change="waterAccountFlagChange">
								</el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item label="水费价格" label-width="140px">
								<el-input v-model="recordForm.waterPrice" clearable :disabled="waterAccountFlag">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="2">
							<el-form-item :label="electricUniServiceFeeColumnName">
								<el-checkbox v-model="recordForm.electricPriceServiceFeeUniFlag" true-label="1" false-label="0" :disabled="electricAccountFlag"></el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item :label="electricServiceFeePriceColumnName" label-width="140px">
								<el-input v-model="recordForm.electricPriceServiceFee" clearable :disabled="electricAccountFlag">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :md="2">
							<el-form-item :label="waterUniServiceFeeColumnName">
								<el-checkbox v-model="recordForm.waterPriceServiceFeeUniFlag" true-label="1" false-label="0" :disabled="waterAccountFlag">
								</el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item :label="waterServiceFeePriceColumnName" label-width="140px">
								<el-input v-model="recordForm.waterPriceServiceFee" clearable :disabled="waterAccountFlag">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户电账户当前金额" prop="electricBalance">
								<el-input v-model="recordForm.electricBalance"
									oninput="value=value.replace(/[^.-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
									clearable :disabled="electricAccountFlag"></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="商户水账户当前金额" prop="waterBalance">
								<el-input v-model="recordForm.waterBalance"
									oninput="value=value.replace(/[^.-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
									clearable :disabled="waterAccountFlag"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="业态" prop="type">
								<el-select v-model="recordForm.type" placeholder="请选择" style="width: 100%" clearable>
									<el-option v-for="item in lesseeTypeOptions" :key="item.key" :label="item.value"
										:value="item.key"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="备注">
								<el-input v-model="recordForm.remark" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-button type="primary" @click="addElectricMeterDialog"
								style="background-color: #1abc9c !important" :disabled="electricAccountFlag">新增商户电表
							</el-button>
						</el-col>
						<el-col :span="12">
							<el-button type="primary" @click="addWaterMeterDialog"
								style="background-color: #23c6c8 !important" :disabled="waterAccountFlag">新增商户水表
							</el-button>
						</el-col>
					</el-row>
				</el-form>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-table :data="electricTableData" style="width: 100%" class="tableStyle">
							<el-table-column prop="meterAddr" label="电表编号" align="center">
							</el-table-column>
							<el-table-column prop="model" label="电表型号" align="center">
							</el-table-column>
							<el-table-column prop="producer" label="电表厂商" align="center">
							</el-table-column>
							<el-table-column prop="type" label="电表制式" align="center">
							</el-table-column>
							<el-table-column prop="startDegree" label="开始度数(kW·h)" align="center">
							</el-table-column>
							<el-table-column label="操作" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="text" icon="el-icon-delete"
										@click="handleDeleteRow(scope.$index, electricTableData)" class="deleteStyle">删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="12">
						<el-table :data="waterTableData" style="width: 100%" class="tableStyle">
							<el-table-column prop="meterAddr" label="水表编号" align="center">
							</el-table-column>
							<el-table-column prop="model" label="水表型号" align="center">
							</el-table-column>
							<el-table-column prop="producer" label="水表厂商" align="center">
							</el-table-column>
							<el-table-column prop="startDegree" label="起始水底数(m³)" align="center">
							</el-table-column>
							<el-table-column label="操作" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="text" icon="el-icon-delete"
										@click="handleDeleteRow(scope.$index, waterTableData)" class="deleteStyle">删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>

				<div style="margin: 20px 0 40px 0">
					<el-button type="primary" @click="openAcountClick">开户</el-button>
				</div>
				<!-- <el-button type="primary" plain>返回</el-button> -->
			</div>
		</el-card>

		<el-dialog title="新增商户电表" :visible.sync="addElectricVis" width="850px">
			<el-form ref="addElectricForm" :model="addElectricForm" label-width="125px" size="small"
				:rules="addElectricFormRules">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="选择已有编号">
							<el-select v-model="addElectricForm.id" placeholder="请选择" filterable clearable
								@clear="addElectricForm = {}" @change="meterIdChange">
								<el-option v-for="item in meterIdOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-button type="primary" style="margin-left: 30px" @click="addNewElectricMeter">新增电表
						</el-button>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="电表编号">
							<el-input v-model="addElectricForm.meterAddr" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电表型号">
							<el-input v-model="addElectricForm.model" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="电表制式">
							<el-select v-model="addElectricForm.type" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in meterTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电表厂商">
							<el-select v-model="addElectricForm.producer" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in producerOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="终端类型">
							<el-select v-model="addElectricForm.terminalId" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in terminalOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电表接线方式">
							<el-select v-model="addElectricForm.wiringMode" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in wiringModeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="操作者">
							<el-input v-model="addElectricForm.operator" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作密码">
							<el-input v-model="addElectricForm.password" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<!-- <el-col :span="12">
            <el-form-item label="商户地址">
              <el-input
                v-model="addElectricForm.roomAddr"
                :disabled="newMeterFlag"
              ></el-input>
            </el-form-item>
          </el-col> -->
					<el-col :span="12">
						<el-form-item label="备注">
							<el-input v-model="addElectricForm.remark" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="CT变比" prop="ctRatio">
							<el-input v-model="addElectricForm.ctRatio" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item label="开始度数(kW·h)" prop="startDegree">
							<el-input v-model="addElectricForm.startDegree" clearable
								@input="startDegree = addElectricForm.startDegree"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindElectricMeter">绑 定</el-button>
				<el-button @click="addElectricVis = false">返 回</el-button>
			</span>
		</el-dialog>
		<el-dialog title="新增商户水表" :visible.sync="addWaterVis" width="800px">
			<el-form ref="addWaterForm" :rules="addWaterFormRules" :model="addWaterForm" label-width="125px"
				size="small">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="选择已有编号">
							<el-select v-model="addWaterForm.id" placeholder="请选择" filterable clearable
								@clear="addWaterForm = {}" @change="waterMeterIdChange">
								<el-option v-for="item in waterMeterIdOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-button type="primary" style="margin-left: 30px" @click="addNewWaterMeter">新增水表</el-button>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="水表编号">
							<el-input v-model="addWaterForm.meterAddr" clearable :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="水表型号">
							<el-input v-model="addWaterForm.model" clearable :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="操作者">
							<el-input v-model="addWaterForm.operator" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作密码">
							<el-input v-model="addWaterForm.password" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="水表厂商">
							<el-select v-model="addWaterForm.producer" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in waterProducerOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="终端类型">
							<el-select v-model="addWaterForm.terminalId" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in terminalWaterOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item label="起始水底数(m³)" prop="startDegree">
							<el-input v-model="addWaterForm.startDegree" clearable
								@input="startDegree = addWaterForm.startDegree"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindWaterMeter">绑 定</el-button>
				<el-button @click="addWaterVis = false">返 回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCode,
		selectOne,
		addMeter,
		openAccount,
		detail,
		detailWater,
		selectOneWater,
		addWaterMeter,
		systemCustomConfig
	} from '../../api/merchant/openAccount';
	import codeConstant from '../../constant/codeConstant';
	import {
		selectMeterTerminalList,
		selectDictionaryListByName,
		selectUnUseMeter,
		selectMeterProducerList,
		selectUnUseWaterMeter,
		selectComboboxTreeData,
		selectWaterProducerList,
		selectWaterTerminalList,
	} from '../../api/comboboxLoad';
	import {
		cascaderAfferentString,
		cascaderAfferentNumber,
	} from '../../untils/func.js';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import systemConstant from '../../constant/systemConstant.js'
	export default {
		data() {
			return {
				recordForm: {
					code: '',
					name: '',
					contactMan: '',
					systemAdmin: '',
					phone: '',
					systemAdminPhone: '',
					address: '',
					type: '',
					electricBalance: '',
					waterBalance: '',
					districtData: '',
					districtId: '',
					enableElectricAccountFlag: "1",
					enableWaterAccountFlag: "1",
					electricPrice: '',
					waterPrice: '',
					electricPriceServiceFeeUniFlag: "1",
					waterPriceServiceFeeUniFlag: "1",
					electricPriceServiceFee: '',
					waterPriceServiceFee: ''
				},
				recordFormRules: {
					code: [{
						required: true,
						message: '请输入商户编号',
						trigger: 'blur',
					}, ],
					name: [{
						required: true,
						message: '请输入商户名称',
						trigger: 'blur',
					}, ],
					contactMan: [{
						required: true,
						message: '请输入商户联系人',
						trigger: 'blur',
					}, ],
					systemAdmin: [{
						required: true,
						message: '请输入小程序联系人',
						trigger: 'blur',
					}, ],
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur',
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位手机号码',
							trigger: 'blur',
						},
						{
							pattern: /^\d{11}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
					systemAdminPhone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur',
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位手机号码',
							trigger: 'blur',
						},
						{
							pattern: /^\d{11}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
					districtId: [{
						required: true,
						message: '请选择区域',
						trigger: 'change',
					}, ],
					type: [{
						required: true,
						message: '请选择业态',
						trigger: 'change',
					}, ],
					electricBalance: [{
							required: true,
							trigger: 'blur',
							message: '请输入商户电账户当前金额',
						},
						{
							pattern: /(^([-+])?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^([-+])?[0-9]\.[0-9]([0-9])?$)/,
							message: '请输入正确金额格式,可保留两位小数',
						},
					],
					waterBalance: [{
							required: true,
							trigger: 'blur',
							message: '请输入商户水账户当前金额',
						},
						{
							pattern: /(^([-+])?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^([-+])?[0-9]\.[0-9]([0-9])?$)/,
							message: '请输入正确金额格式,可保留两位小数',
						},
					],
				},
				props: {
					expandTrigger: 'hover',
				},
				addElectricForm: {
					id: '',
					startDegree: '',
				},
				addElectricFormRules: {
					startDegree: [{
						required: true,
						message: '请输入开始度数',
						trigger: 'blur',
					}, ],
				},
				addWaterForm: {
					id: '',
					startDegree: '',
				},
				addWaterFormRules: {
					startDegree: [{
						required: true,
						message: '请输入起始水底数',
						trigger: 'blur',
					}, ],
				},
				addElectricVis: false,
				addWaterVis: false,
				lesseeTypeOptions: [], //业态 options
				meterIdOptions: [], //未绑定电表编号 options
				terminalOptions: [], // 电表终端类型options
				terminalWaterOptions: [], // 水表终端类型options
				wiringModeOptions: [], //电表接线方式options
				producerOptions: [], //厂商类型options
				waterProducerOptions: [], //厂商类型options
				meterTypeOptions: [], //电表制式options
				newMeterFlag: true,
				electricTableData: [], //电表table数据
				waterTableData: [], //水表table数据
				startDegree: null,
				waterMeterIdOptions: [], //未绑定水表编号 options
				districtIdOptions: [], // 区域 options
				electricAccountFlag: false,
				waterAccountFlag: false,
				electricUniServiceFeeColumnName: '',
				electricServiceFeePriceColumnName: '',
				waterUniServiceFeeColumnName: '',
				waterServiceFeePriceColumnName: '',
			};
		},
		created() {
			this.electricUniServiceFeeColumnName = "统一" + this.$root.serviceFeeNameElectric;
			this.electricServiceFeePriceColumnName = this.$root.serviceFeeNameElectric + "价格" ;
			this.waterUniServiceFeeColumnName = "统一" + this.$root.serviceFeeNameWater;
			this.waterServiceFeePriceColumnName = this.$root.serviceFeeNameWater + "价格" ;
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.getLesseeType();
				// 下拉列表数据
				await this.getWiringMode();
				await this.getMeterProducer();
				await this.getSelectWaterProducerList();
				await this.getMeterType();
				await this.getTerminalId();
				await this.getSelectWaterTerminalList();
				await this.selectComboboxTreeData();
				await this.systemCustomConfigElectric();
				await this.systemCustomConfigWater();
			},
			// 打开 新增商户电表 对话框
			async addElectricMeterDialog() {
				this.addElectricForm = {};
				this.startDegree = null;
				this.newMeterFlag = true;
				this.addElectricVis = true;
				await this.getSelectUnUseMeter();
			},
			// 打开 新增商户水表 对话框
			async addWaterMeterDialog() {
				this.addWaterForm = {};
				this.startDegree = null;
				this.addWaterVis = true;
				this.newMeterFlag = true;
				await this.getSelectUnUseWaterMeter();
			},
			// 新增电表按钮
			addNewElectricMeter() {
				this.newMeterFlag = false;
				this.addElectricForm = {};
				this.startDegree = null;
			},
			// 新增水表按钮
			addNewWaterMeter() {
				this.newMeterFlag = false;
				this.addWaterForm = {};
				this.startDegree = null;
			},
			// 已有编号电表 change事件
			async meterIdChange() {
				this.newMeterFlag = true;
				await this.getMeterDetail();
			},
			// 根据已有编号 id 查询电表
			async getMeterDetail() {
				const res = await detail({
					id: this.addElectricForm.id,
				}).then();
				this.addElectricForm = res.data;
			},

			// 已有编号水表 change事件
			async waterMeterIdChange() {
				this.newMeterFlag = true;
				await this.getWaterMeterDetail();
			},
			// 根据已有编号 id 查询水表
			async getWaterMeterDetail() {
				const res = await detailWater({
					id: this.addWaterForm.id,
				}).then();
				this.addWaterForm = res.data;
				console.log(this.addWaterForm);
			},
			// 电表查询
			async getSelectOne() {
				const res = await selectOne({
					id: this.addElectricForm.id,
				}).then();
				this.addElectricForm = res.data;
			},
			// 绑定电表
			async bindElectricMeter() {
				this.$refs.addElectricForm.validate(async (valid) => {
					if (valid) {
						if (this.newMeterFlag) {
							await addMeter(this.addElectricForm).then();
							await this.getSelectOne();
						} else {
							const id = await addMeter(this.addElectricForm).then();
							this.addElectricForm.id = id.data;
							this.msgSuccess('新增电表成功');
						}
						let type = null;
						for (let i = 0; i < this.meterTypeOptions.length; i++) {
							if (this.addElectricForm.type == this.meterTypeOptions[i].key) {
								type = this.meterTypeOptions[i].value;
							}
						}
						let producer = null;
						for (let i = 0; i < this.producerOptions.length; i++) {
							if (this.addElectricForm.producer == this.producerOptions[i].key) {
								producer = this.producerOptions[i].value;
							}
						}
						let coulum = {
							meterId: this.addElectricForm.id,
							meterAddr: this.addElectricForm.meterAddr,
							model: this.addElectricForm.model,
							producer: producer || this.addElectricForm.producer,
							type: type || this.addElectricForm.type,
							startDegree: this.startDegree,
						};
						this.electricTableData.push(coulum);
						this.addElectricVis = false;
					} else {
						this.msgError('信息填写错误');
						return false;
					}
				});
			},
			// 水表查询
			async getSelectOneWater() {
				const res = await selectOneWater({
					id: this.addWaterForm.id,
				}).then();
				this.addWaterForm = res.data;
			},
			// 绑定水表
			async bindWaterMeter() {
				this.$refs.addWaterForm.validate(async (valid) => {
					if (valid) {
						if (this.newMeterFlag) {
							await addWaterMeter(this.addWaterForm).then();
							await this.getSelectOneWater();
						} else {
							const id = await addWaterMeter(this.addWaterForm).then();
							this.addWaterForm.id = id.data;
							this.msgSuccess('新增水表成功');
						}
						let producer = null;
						for (let i = 0; i < this.waterProducerOptions.length; i++) {
							if (
								this.addWaterForm.producer == this.waterProducerOptions[i].key
							) {
								producer = this.waterProducerOptions[i].value;
							}
						}
						let coulum = {
							meterId: this.addWaterForm.id,
							meterAddr: this.addWaterForm.meterAddr,
							model: this.addWaterForm.model,
							producer: producer || this.addWaterForm.producer,
							startDegree: this.startDegree,
						};
						this.waterTableData.push(coulum);
						this.addWaterVis = false;
					} else {
						this.msgError('请填写必填项');
						return false;
					}
				});
			},
			// 删除table当前行数据
			handleDeleteRow(index, rows) {
				rows.splice(index, 1);
			},
			// 开户
			openAcountClick() {
				this.$refs.recordForm.validate(async (valid) => {
					if (valid) {
						let res = this.recordForm;
						if (res.districtId.constructor === Array) {
							res.districtData = cascaderAfferentString(res.districtId);
							res.districtId = cascaderAfferentNumber(res.districtId);
						}
						let params = {
							openAccountBodyVos: [],
							openAccountHeadVo: res,
							openAccountWaterBodyVos: [],
						};
						this.electricTableData.forEach((element) => {
							let bodyVos = {
								meterId: element.meterId,
								startDegree: element.startDegree,
							};
							params.openAccountBodyVos.push(bodyVos);
						});
						this.waterTableData.forEach((element) => {
							let bodyVos = {
								meterId: element.meterId,
								startDegree: element.startDegree,
							};
							params.openAccountWaterBodyVos.push(bodyVos);
						});
						await openAccount(params).then();
						this.msgSuccess('开户成功');
						this.recordForm = {
							code: '',
						};
						this.electricTableData = [];
						this.waterTableData = [];
					} else {
						this.msgError('信息填写错误');
						return false;
					}
				});
			},

			// 获取下拉列表 数据
			async getWiringMode() {
				// 接线方式
				const res1 = await selectDictionaryListByName(
					dictionaryConstant.METER_CONNECT_TYPE
				).then();
				this.wiringModeOptions = res1.data;
			},
			async getMeterProducer() {
				// 电表厂商类型
				const res2 = await selectMeterProducerList().then();
				this.producerOptions = res2.data;
			},
			async getSelectWaterProducerList() {
				// 水表厂商类型
				const res2 = await selectWaterProducerList().then();
				this.waterProducerOptions = res2.data;
			},
			async getMeterType() {
				// 电表制式
				const res3 = await selectDictionaryListByName(
					dictionaryConstant.METER_TYPE
				).then();
				this.meterTypeOptions = res3.data;
			},
			async getTerminalId() {
				// 电表终端类型
				const res4 = await selectMeterTerminalList().then();
				this.terminalOptions = res4.data;
			},
			async getSelectWaterTerminalList() {
				// 水表终端类型
				const res = await selectWaterTerminalList().then();
				this.terminalWaterOptions = res.data;
			},
			// 获取商户编号
			async getMerchantType() {
				const res = await getCode({
					type: codeConstant.CODE_TYPE_LESSEE_CODE,
				}).then();
				this.recordForm.code = res.data;
			},
			// 获取业态下拉列表数据
			async getLesseeType() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.LESSEE_TYPE
				).then();
				this.lesseeTypeOptions = res.data;
			},
			// 获取未绑定电表下拉列表数据
			async getSelectUnUseMeter() {
				const res = await selectUnUseMeter().then();
				this.meterIdOptions = res.data;
			},
			// 获取未绑定水表下拉列表数据
			async getSelectUnUseWaterMeter() {
				const res = await selectUnUseWaterMeter().then();
				this.waterMeterIdOptions = res.data;
			},
			// 区域下拉框
			async selectComboboxTreeData() {
				const res = await selectComboboxTreeData().then();
				this.districtIdOptions = res.data;
			},
			// 单机开启电账户复选框改变事件
			electricAccountFlagChange(e) {
				if (e == "1") {
					this.electricAccountFlag = false;
					this.systemCustomConfigElectric();
				} else {
					this.electricAccountFlag = true;
					this.recordForm.electricPrice = 0;
					this.recordForm.electricBalance = 0;

				}
			},
			// 单机开启水账户复选框改变事件
			waterAccountFlagChange(e) {
				if (e == "1") {
					this.waterAccountFlag = false;
					this.systemCustomConfigWater();
				} else {
					this.waterAccountFlag = true;
					this.recordForm.waterPrice = 0;
					this.recordForm.waterBalance = 0;
				}
			},
			// 查询电费
			async systemCustomConfigElectric() {
				const res = await systemCustomConfig({
					dicKey: systemConstant.PRICE_ELECTRIC
				}).then();
				this.recordForm.electricPrice = res.data;
			},
			// 查询水费
			async systemCustomConfigWater() {
				const res = await systemCustomConfig({
					dicKey: systemConstant.PRICE_WATER
				}).then();
				this.recordForm.waterPrice = res.data;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	// @media screen and (max-width: 1000px) {
	//   .centerBox {
	//     width: 100% !important;
	//   }
	// }
	.centerBox {
		width: 100%;
		margin: 0 auto;
		text-align: center;
	}

	/deep/ .el-select {
		width: 100%;
	}

	// /deep/ .el-form-item {
	//   margin-bottom: 15px;
	// }
	/deep/ .el-table .el-table__cell {
		padding: 5px 0;
	}

	/deep/ .el-cascader {
		width: 100%;
	}

	.tableStyle {
		margin: 20px 0;
		box-shadow: 0px 0px 5px 2px #eee;
	}

	.deleteStyle:hover {
		color: var(--menuActiveText) !important;
	}
</style>
